<template>
    <div class="tablelist">
        <a-table
            size="middle"
            :key="this.loading.key"
            :columns="columns"
            :rowKey="record => record.id ? record.id : Math.random()"
            :dataSource="list"
            :pagination="false"
            :loading="this.loading.effects[selectType]"
        >
            <template slot="operation" slot-scope="text,record">
                <a class="mr10" @click="e=>editserver(record,e)">修改</a>
                <a-popconfirm title="确认删除?" @confirm="e => onDelete(record, e)">
                    <a :disabled="that.loading.effects[deleteType]" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <v-pageinfo v-if="pagination.total > 0" :pagination="pagination"></v-pageinfo>
        <v-dynattr :key="modalkey" :visible="visible" :record="record" action="edit"></v-dynattr>
    </div>
</template>

<script>
import { mapState } from "vuex";
import DynAttrs from "./components/DynAttrs.vue";

const storeNamespace = "rc_io";

// const columns = []

export default {
    components: {
        "v-dynattr": DynAttrs
    },
    data() {
        return {
            that: this,
            modalkey: Math.random(),
            record: {},
            storeNamespace,
            selectType: `${storeNamespace}/configlist`,
            addType: `${storeNamespace}/addconfig`,
            deleteType: `${storeNamespace}/delconfig`,
            form: this.$form.createForm(this),
            visible: false,
            columns: [
                {
                    title: "序号",
                    width: 80,
                    align: "center",
                    customRender: (text, record, index) => ++index
                },
                {
                    title: "配置名称",
                    dataIndex: "configname"
                },
                {
                    title: "配置内容",
                    dataIndex: "config",
                    customRender: text => {
                        return (
                            <div title={text}>
                                {this.lodash.truncate(text, { length: 30 })}
                            </div>
                        );
                    }
                },
                {
                    title: "创建时间",
                    dataIndex: "createtime"
                },
                {
                    title: "操作",
                    width: 146,
                    scopedSlots: { customRender: "operation" }
                }
            ],
            action: ""
        };
    },
    methods: {
        //删除
        onDelete(record, e) {
            e.preventDefault();
            this.$store.dispatch({
                type: this.deleteType,
                params: record
            });
        },
        editserver(record, e) {
            e.preventDefault();
            this.record = record;
            this.visible = true;
            this.modalkey = new Date().getTime();
            // this.showModal();
            /* this.$store.dispatch({
                type: this.addType,
                params: record
            }); */
        }
    },
    computed: {
        ...mapState(storeNamespace, {
            list: state => state.configlist,
            pagination: state => {
                return state.configpagination;
            },
            data: state => state.configdata
        })
    },
    beforeMount() {},
    mounted() {
        this.$store.dispatch({
            type: this.selectType
        });
    }
};
</script>
<style lang="less" scoped>
</style>
